import { CustomRouteActivityType } from '@alltrails/types/CustomRoute';
import type MetadataActivityType from '../types/MetadataActivityType';

const getMetadataActivityType = (activityType: CustomRouteActivityType): MetadataActivityType | undefined => {
  switch (activityType) {
    case 'backpacking':
    case 'hiking':
      return 'hiking';
    case 'mountain-biking':
      return 'mountain_biking';
    case 'running':
      return 'running';
    case 'road-biking':
      return 'cycling';
    case 'trail-running':
      return 'trail_running';
    default:
      return undefined;
  }
};

export default getMetadataActivityType;
